import React, { useRef, useEffect } from "react";
import { X } from "lucide-react";

const Modal = ({ open, onClose, children, className = "", align = "center", closeSize = 20 }) => {
  // Hooks must be at top level — before any conditional return
  const pressedOnBackdrop = useRef(false);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  const alignClass =
    align === "bottom"
      ? "items-end sm:items-center"
      : "items-center";

  const overlayPad = align === "bottom" ? "p-2 sm:p-4" : "p-4";

  return (
    <div
      className={`fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center ${alignClass} z-50 ${overlayPad}`}
      onMouseDown={(e) => { pressedOnBackdrop.current = e.target === e.currentTarget; }}
      onClick={() => { if (pressedOnBackdrop.current) onClose(); }}
    >
      <div
        className={`relative bg-surface-lowest rounded-2xl shadow-2xl border border-surface-container/50 w-full max-w-lg animate-fadeIn ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-2 right-2 p-2 rounded-full text-on-surface-variant hover:text-on-primary-fixed-var hover:bg-surface-low z-10"
            aria-label="Close"
          >
            <X size={closeSize} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
